(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[671],{

/***/ 4040:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/post/[slug]",
      function () {
        return __webpack_require__(6921);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



var Advert = function(param) {
    var language = param.language;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (true) {
            window.adsbygoogle = window.adsbygoogle || [];
            window.adsbygoogle.push({});
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            background: "#ffffff07",
            marginTop: "1rem"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: language === "en" ? "Advertisement" : "Mainos"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
                className: "adsbygoogle",
                style: {
                    display: "block"
                },
                "data-ad-client": "ca-pub-5560402633923389",
                "data-ad-slot": "1051764153",
                "data-ad-format": "auto",
                "data-full-width-responsive": "true"
            })
        ]
    }, router.asPath);
};
/* harmony default export */ __webpack_exports__["Z"] = (Advert);


/***/ }),

/***/ 4438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2106);
/* harmony import */ var _styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2__);



var Post = function(param) {
    var post = param.post, _compact = param.compact, compact = _compact === void 0 ? false : _compact, language = param.language;
    var blogInLanguage = language === "en" ? "blog" : "blogi";
    var postInLanguage = language === "en" ? "post" : "julkaisu";
    var pageInLanguage = language === "en" ? "page" : "sivu";
    if (typeof post.tags === "string") {
        post.tags = post.tags.split(",").map(function(tag) {
            return tag.trim();
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Post),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Title),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/".concat(post.altPath || "".concat(blogInLanguage, "/").concat(postInLanguage), "/").concat(post.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: post.title
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Excerpt),
                children: post.excerpt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Tags),
                children: post.tags && post.tags.map(function(tag) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/".concat(blogInLanguage, "/").concat(tag.toLowerCase(), "/").concat(pageInLanguage, "/1"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Tag),
                            children: tag
                        })
                    }, tag);
                })
            }),
            !compact && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/".concat(post.altPath || "".concat(blogInLanguage, "/").concat(postInLanguage), "/").concat(post.slug),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    "aria-label": "".concat(language === "en" ? "Open post" : "Avaa julkaisu", " ").concat(post.title),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                        children: [
                            language === "en" ? "Read more" : "Lue lis\xe4\xe4",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Arrow),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Post);


/***/ }),

/***/ 5453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Post__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4438);
/* harmony import */ var _styles_PostRecommendation_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2967);
/* harmony import */ var _styles_PostRecommendation_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_PostRecommendation_module_css__WEBPACK_IMPORTED_MODULE_2__);



var PostRecommendation = function(param) {
    var language = param.language, _posts = param.posts, posts = _posts === void 0 ? [] : _posts;
    if (!posts || posts.length === 0) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_PostRecommendation_module_css__WEBPACK_IMPORTED_MODULE_2___default().PostRecommendation),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: language === "fi" ? "Muita julkaisuja" : "Explore Other Posts"
            }),
            posts.map(function(post) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Post__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    post: post,
                    compact: false,
                    language: language
                }, post.slug);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostRecommendation);


/***/ }),

/***/ 5918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sharelinks */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_SocialShareButtons_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9254);
/* harmony import */ var _styles_SocialShareButtons_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_SocialShareButtons_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(944);




var sharelinks = [
    {
        iconName: "facebook",
        href: "https://www.facebook.com/sharer/sharer.php?u=__URL__",
        ariaLabel: "Share on Facebook"
    },
    {
        iconName: "twitter",
        href: "http://twitter.com/intent/tweet?url=__URL__&hashtags=__TAGS__",
        ariaLabel: "Share on Twitter"
    },
    {
        iconName: "whatsapp",
        href: "https://wa.me/?text=__URL__",
        ariaLabel: "Share on Whatsapp"
    },
    {
        iconName: "linkedin",
        href: "https://www.linkedin.com/shareArticle?mini=true&url=__URL__&text=__TITLE__",
        ariaLabel: "Share on LinkedIn"
    }, 
];
var SocialShareButtons = function(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, _text = param.text, text = _text === void 0 ? "" : _text, _tags = param.tags, tags = _tags === void 0 ? "" : _tags, _language = param.language, language = _language === void 0 ? "" : _language;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var currentPath = router.pathname.replace("[slug]", router.query.slug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_SocialShareButtons_module_css__WEBPACK_IMPORTED_MODULE_3___default().SocialShareButtons),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: language === "fi" ? "Jaa sosiaalisessa mediassa:" : "Share on social media:"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: sharelinks.map(function(sharelink) {
                    var href = sharelink.href.replace("__URL__", "https://niemenjoki.fi" + currentPath).replace("__TITLE__", title).replace("__TAGS__", tags);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: href,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-testid": sharelink.iconName,
                        "aria-label": sharelinks.ariaLabel,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            name: sharelink.iconName
                        })
                    }, sharelink.iconName);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialShareButtons);


/***/ }),

/***/ 6921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Advert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1682);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3510);
/* harmony import */ var _components_PostRecommendation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5453);
/* harmony import */ var _components_SocialShareButtons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5918);
/* harmony import */ var _styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4854);
/* harmony import */ var _styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_5__);






var PostPage = function(param) {
    var data = param.data, content = param.content, recommendedPosts = param.recommendedPosts;
    var title = data.title, date = data.date, tags = data.tags, excerpt = data.excerpt, i18n = data.i18n;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: title + " | Joonas Niemenjoki",
        ads: true,
        description: excerpt,
        language: "en",
        i18n: i18n,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                className: (_styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_5___default().PostPage),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_5___default().Date),
                        children: [
                            "Published: ",
                            date
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_5___default().Content),
                        dangerouslySetInnerHTML: {
                            __html: content
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SocialShareButtons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: title,
                text: excerpt,
                tags: tags,
                language: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Advert__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                language: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PostRecommendation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                language: "en",
                posts: recommendedPosts
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PostPage);


/***/ }),

/***/ 2106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Post":"Post_Post__y18Vk","Title":"Post_Title__iKyDh","Excerpt":"Post_Excerpt__yMdge","Tags":"Post_Tags__we__h","Tag":"Post_Tag__D57Ir","Arrow":"Post_Arrow__jth_i"};

/***/ }),

/***/ 4854:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PostPage":"PostPage_PostPage__Do8bS","Date":"PostPage_Date__OOjIf","Kryptex":"PostPage_Kryptex__PBD5I","Content":"PostPage_Content__SNKq9","Taglist":"PostPage_Taglist__YU7IE","Tag":"PostPage_Tag__Jnmr6","ActiveTag":"PostPage_ActiveTag__lWA0z"};

/***/ }),

/***/ 2967:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PostRecommendation":"PostRecommendation_PostRecommendation__2Z8Tf"};

/***/ }),

/***/ 9254:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SocialShareButtons":"SocialShareButtons_SocialShareButtons__hqxIP"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,913,510,774,888,179], function() { return __webpack_exec__(4040); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);